/**
 * Confidence Badge Component
 *
 * Shows a small amber warning badge for heuristic detections.
 * Deterministic detections show nothing (clean UI = no warning needed).
 * Hovering shows the reason why this was flagged as heuristic.
 */

interface ConfidenceBadgeProps {
  confidence?: 'deterministic' | 'heuristic';
  reason?: string;
}

export function ConfidenceBadge({ confidence, reason }: ConfidenceBadgeProps) {
  if (!confidence || confidence === 'deterministic') return null;

  return (
    <span
      className="inline-flex items-center gap-1 px-1.5 py-0.5 text-xs rounded bg-amber-100 text-amber-700 border border-amber-200 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-700"
      title={reason || 'Detected via heuristic pattern matching — may not be accurate'}
    >
      <svg className="w-3 h-3" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.168 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
      </svg>
      Heuristic
    </span>
  );
}
